import { Loading } from './styles';

export function EditorLoading() {
  return <Loading />;
}
